module.exports = __webpack_public_path__ + "static/media/wpp-comparativo.6d9a7601.png";